import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  cleanServingPerRecipeValue,
  cleanServingValue,
  cleanYieldValue,
} from '@app/mpp/pages/recipe-detail/helper/recipe-detail-helper';

@Component({
  selector: 'app-edit-portion',
  templateUrl: './edit-portion.component.html',
  styleUrls: ['./edit-portion.component.scss'],
})
export class EditPortionComponent {
  @Input() yield: number;
  @Input() serving: number;
  @Input() servingPerRecipe: number;
  @Input() servingUOM: string;
  @Input() yieldUOM: string;
  @Input() recipeDetailPage = false;
  @Input() lockEdits = false;

  @Output() yieldValueEvent = new EventEmitter<number>();
  @Output() servingValueEvent = new EventEmitter<number>();
  @Output() servingPerRecipeEvent = new EventEmitter<number>();
  @Output() servingUOMEvent = new EventEmitter<Event>();
  @Output() yieldUOMEvent = new EventEmitter<Event>();

  constructor() {}

  onYieldChange(event: any) {
    this.yieldValueEvent.emit(cleanYieldValue(event?.target?.value));
  }

  onServingChange(event: any) {
    this.servingValueEvent.emit(cleanServingValue(event?.target?.value));
  }

  onServingPerRecipe(event: any) {
    const cleanedValue = cleanServingPerRecipeValue(event?.target?.value);
    this.servingPerRecipe = cleanedValue;
    this.servingPerRecipeEvent.emit(cleanedValue);
  }

  onShowServingUOM(event: Event) {
    this.servingUOMEvent.emit(event);
  }

  onShowYieldUOM(event: Event) {
    this.yieldUOMEvent.emit(event);
  }
}
